module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/1-dd467b3bcc4e9eaddfa0c111b81e7987.webm";